import { render, staticRenderFns } from "./ApiKeys.vue?vue&type=template&id=0be5794d&scoped=true&"
import script from "./ApiKeys.vue?vue&type=script&lang=js&"
export * from "./ApiKeys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be5794d",
  null
  
)

export default component.exports